import {
    CLEAR_DOWNLOAD_APK,
    DOWNLOAD_APK_ERROR,
    DOWNLOAD_APK_ERROR_CLEAR,
    DOWNLOAD_APK_PENDING,
    SET_DOWNLOAD_APK_SUCCESS,
} from "./constants"

const initialState = {
    //-----------------------------|| DETAILS ||------------------------------------------------------------
    downloadAPKSuccess: false,
    isDownloadAPKPending: false,
    downloadAPKErrorMessage: null,
}

const farmRecords = (state = initialState, action) => {

    switch (action.type) {
        //-----------------------------|| DETAILS ||---------------------------------------------------------------
        case DOWNLOAD_APK_PENDING: {
            return {
                ...state,
                isDownloadAPKPending: true,
                downloadAPKSuccess: false,
                downloadAPKErrorMessage: null,
            }
        }

        case SET_DOWNLOAD_APK_SUCCESS: {
            return {
                ...state,
                downloadAPKSuccess: true,
                isDownloadAPKPending: false,
                downloadAPKErrorMessage: null,
            }
        }

        case DOWNLOAD_APK_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                downloadAPKErrorMessage: errorMessage,
                isDownloadAPKPending: false,
                downloadAPKSuccess: false,
            }
        }

        case DOWNLOAD_APK_ERROR_CLEAR: {
            return {
                ...state,
                downloadAPKErrorMessage: null,
                //  isDownloadAPKPending: false,
            }
        }
        case CLEAR_DOWNLOAD_APK: {
            return {
                ...state,
                downloadAPKSuccess: false,
            }
        }

        default: {
            return state;
        }
    }
}

export default farmRecords;